export const objectifsPro = [
  { value: 'conformite', label: 'Mise en conformité réglementaire' },
  { value: 'maintien', label: 'Maintien/actualisation des compétences' },
  { value: 'developpement', label: 'Développement des compétences opérationnelles' },
  { value: 'reduction_risques', label: 'Réduction des risques professionnels' },
  { value: 'procedures', label: 'Mise en place/amélioration des procédures internes' },
  { value: 'referents', label: 'Formation de référents/équipiers sécurité' },
  { value: 'sensibilisation', label: 'Sensibilisation des équipes' },
  { value: 'journee_securite', label: 'Journée sécurité/événement interne' },
  { value: 'assureur', label: 'Exigence assureur' },
  { value: 'incident', label: 'Suite à un incident/contrôle' },
  { value: 'autre', label: 'Autre' },
]

export const contraintesAcces = [
  { value: 'piece_identite', label: 'Pièce d\'identité obligatoire : carte nationale d\'identité (CNI) ou passeport' },
  { value: 'poste_garde', label: 'Accueil et enregistrement au poste de garde / PC sécurité' },
  { value: 'fouille_vehicule', label: 'Fouille véhicule' },
  { value: 'autre', label: 'Autre' },
]

export const epiOptions = [
  { value: 'chaussures_securite', label: 'Chaussures de sécurité' },
  { value: 'casque', label: 'Casque' },
  { value: 'gilet', label: 'Gilet de sécurité' },
  { value: 'autre', label: 'Autre' },
]

export const materielSalle = [
  { value: 'chaises', label: 'Chaises' },
  { value: 'tables', label: 'Tables' },
  { value: 'videoprojecteur', label: 'Vidéoprojecteur' },
  { value: 'ecran', label: 'Écran de projection' },
  { value: 'tableau_blanc', label: 'Tableau blanc' },
  { value: 'wifi', label: 'Wi-Fi disponible' },
  { value: 'reseau_mobile', label: 'Réseau mobile disponible (4G / 5G)' },
]

export const handicapTypes = [
  { value: 'moteur', label: 'Moteur' },
  { value: 'visuel', label: 'Visuel' },
  { value: 'auditif', label: 'Auditif' },
  { value: 'cognitif', label: 'Cognitif' },
]

// Le stationnement du formateur est la même question que dans la demande de
// devis et le tunnel commercial : mêmes réponses, lues dans la même liste.
// Chemin relatif et non `@shared` : ce fichier est aussi chargé par le serveur.
export { STATIONNEMENT_FORMATEUR_OPTIONS as stationnementOptions } from '../../../shared/quote-intra-location.js'

export const paiementOptions = [
  { value: 'virement', label: 'Virement bancaire' },
  { value: 'chorus_mandat', label: 'Chorus Pro mandat administratif' },
]

export const pmrOptions = [
  { value: 'oui', label: 'Oui' },
  { value: 'non', label: 'Non' },
  { value: 'non_concerne', label: 'Non concerné' },
]

export const ouiNonNeSaisPasOptions = [
  { value: 'oui', label: 'Oui' },
  { value: 'non', label: 'Non' },
  { value: 'ne_sait_pas', label: 'Ne sait pas' },
]

export const ouiNonBoolOptions = [
  { value: false, label: 'Non' },
  { value: true, label: 'Oui' },
]

// Même question posée en chaîne : certains champs stockent 'non'/'oui'.
export const ouiNonStringOptions = [
  { value: 'non', label: 'Non' },
  { value: 'oui', label: 'Oui' },
]

export const opcoOptions = [
  { value: 'non', label: 'Non' },
  { value: 'oui_sans_subrogation', label: 'Oui — sans subrogation' },
  { value: 'oui_avec_subrogation', label: 'Oui — avec subrogation' },
]

export const opcoDemandePriseEnChargeOptions = [
  { value: 'oui', label: 'Oui — j\'ai l\'accord de prise en charge' },
  { value: 'en_cours', label: 'En cours — demande déposée' },
  { value: 'non', label: 'Non — pas encore de demande' },
]
